// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../images/backgroupnd/BackgroundImg.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../../images/backgroupnd/Line.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sc-dpBQxM.dgCTQN {
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background: linear-gradient(to top, rgba(0, 0, 0, 0), #160825),
              url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat center center / cover,
              url(${___CSS_LOADER_URL_REPLACEMENT_1___}) no-repeat center center / cover,
              #160825;
}

.loginPage {
  display: flex !important;
  flex-direction: row !important;
  flex-wrap: wrap;
  justify-content: center;
  gap: 50px;
  background: #e1e0e0;
  padding: 10px
}

.text-center {
  height: max-content;
  margin: 15px 0px;
}

.text {
  display: flex;
  flex-basis: 100%;
  align-items: center;
  color: rgba(0, 0, 0, 0.692);
  font-size: 20px;
}

.text::before,
.text::after {
  content: "";
  flex-grow: 1;
  background: rgb(255, 255, 255);
  height: 1px;
  font-size: 0px;
  line-height: -5px;
  margin: 0px 8px;
}

.text-start {
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-between;
  margin: 10px 0;
}

.form-label {
  width: 30%;
} 

.form-control {
  width: 65%
}

.d-grid.gap-2 {
  margin: 5px 0;
}
`, "",{"version":3,"sources":["webpack://./src/ui/login/LoginPage/LoginPage.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB;;;qBAGmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,eAAe;EACf,uBAAuB;EACvB,SAAS;EACT,mBAAmB;EACnB;AACF;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,WAAW;EACX,cAAc;EACd,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,8BAA8B;EAC9B,cAAc;AAChB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE;AACF;;AAEA;EACE,aAAa;AACf","sourcesContent":[".sc-dpBQxM.dgCTQN {\n  width: 100vw;\n  height: 100vh;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background: linear-gradient(to top, rgba(0, 0, 0, 0), #160825),\n              url('../../../images/backgroupnd/BackgroundImg.svg') no-repeat center center / cover,\n              url('../../../images/backgroupnd/Line.svg') no-repeat center center / cover,\n              #160825;\n}\n\n.loginPage {\n  display: flex !important;\n  flex-direction: row !important;\n  flex-wrap: wrap;\n  justify-content: center;\n  gap: 50px;\n  background: #e1e0e0;\n  padding: 10px\n}\n\n.text-center {\n  height: max-content;\n  margin: 15px 0px;\n}\n\n.text {\n  display: flex;\n  flex-basis: 100%;\n  align-items: center;\n  color: rgba(0, 0, 0, 0.692);\n  font-size: 20px;\n}\n\n.text::before,\n.text::after {\n  content: \"\";\n  flex-grow: 1;\n  background: rgb(255, 255, 255);\n  height: 1px;\n  font-size: 0px;\n  line-height: -5px;\n  margin: 0px 8px;\n}\n\n.text-start {\n  display: flex;\n  flex-direction: row;\n  width: 100%;\n  justify-content: space-between;\n  margin: 10px 0;\n}\n\n.form-label {\n  width: 30%;\n} \n\n.form-control {\n  width: 65%\n}\n\n.d-grid.gap-2 {\n  margin: 5px 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
